<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="px-4">
      <div class="container mx-auto mt-4 mb-8">
        <div class="flex basis-1/2 md:flex-nowrap gap-4">
          <div>
            <div
              class="px-4 sm:px-10 p-4 sm:p-8  bg-brand-taupe-700 rounded-lg font-callout text-xl sm:text-1xl font-medium text-white">
              The purpose of this health check for your business is to support you in continually evolving your
              practices and procedures, and to ensure that you have a means of benchmarking what you currently do
              against best practice in the motor fleet sector.
            </div>
          </div>
        </div>
      </div>
      <div class="container mx-auto mt-4">
        <div class="gap-4">
          <p class="mb-4">
            This questionnaire is the first step on your risk management journey
            with AXA, and the process is not necessarily designed to be results
            driven. If there are areas where you would like support or guidance
            then AXA will be able to assist, but the self-assessment aims to
            firstly raise awareness of risk management issues and encourage the
            adoption of quality assurance principles to effectively manage your
            risk.
          </p>
          <p class="mb-4">
            From this initial health check, you will have a high level view
            of the risks most likely to give rise to a motor claim, and whether
            you are currently taking the best steps to protect yourself, your
            business and your drivers.
          </p>
          <p class="mb-4">If needed from here, AXA will be able to
            assist you in developing a more holistic risk management strategy
            through access to our expert team of business resilience managers, and
            a number of free of charge resources at your disposal, or through the
            services offered by our risk management partners.
          </p>
        </div>
      </div>
      <div class="container mt-10 pb-10 mx-auto">
        <div class="flex justify-center">
          <StartReviewButton>
            Start your review today
          </StartReviewButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "../Shared/PageHeader";
import StartReviewButton from "../Shared/StartReviewButton.vue"

export default {
  components: {
    PageHeader,
    StartReviewButton
  },
  data: function () {
    return {
      show: true,
      headingContent: {
        hero: {
          image: '/images/159643845_trucks_hero.jpg',
          title: 'Fleet Risk Review',
          subtitle: 'In association with AXA Insurance',
        },
        page: {
          title: 'About Fleet Risk Review',
          subtitle: '',
        },
      }
    };
  },
};
</script>